// src/components/Pages/Company.js

import { Box, Button, CircularProgress, Container, Grid, Typography } from '@mui/material';

import { useGetCompanyContextQuery } from '../../redux/features/companyApi';

import { CompanyProfile } from '../Apm/Profile/CompanyProfile';

import { CompanyProfileDetails } from '../Apm/Profile/CompanyProfileDetails';

import { CompanyStamp } from '../Apm/Profile/CompanyStamp';

const Company = () => {
  const { data: companyContext, isLoading, isError, refetch } = useGetCompanyContextQuery();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 400,
          width: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !companyContext?.company) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          py: 8,
        }}
      >
        <Typography color="error" align="center">
          Company data could not be loaded.
        </Typography>

        <Button type="button" variant="outlined" onClick={refetch}>
          Retry
        </Button>
      </Box>
    );
  }

  const company = companyContext.company;

  const canEdit = companyContext.can_edit_company;

  return (
    <Container
      maxWidth="lg"
      sx={{
        py: 3,
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <CompanyProfile company={company} canEdit={canEdit} />
        </Grid>

        <Grid item xs={12} md={6}>
          <CompanyStamp company={company} canEdit={canEdit} />
        </Grid>

        <Grid item xs={12}>
          <CompanyProfileDetails company={company} canEdit={canEdit} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Company;
